import { API, axiosInstance } from "lib";

export const getIdfcAccounts = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_GET_ACCOUNTS, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};

export const registerIdfcAccount = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_REGISTER_USER, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};
export const unlinkIdfcAccount = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_DEREGISTER_USER, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};
export const getIdfcAuthUrl = (data = {}) => {
    return axiosInstance
        .post(API.GET_IDFC_AUTH_URL, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};

export const idfcBalanceEnquiry = (data = {}) => {
    return axiosInstance
        .post(API.GET_IDFC_BALANCE, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            return err?.response?.data || err;
        });
};


export const idfcSessionLogout = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_SESSION_LOGOUT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};

export const idfcUpdateAccount = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_UPDATE_ACCOUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};

export const idfcRegisterEnquiry = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_REGISTER_ENQUIRY, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            // throw err;
        });
};

export const idfcMultiPayment = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_MULTI_PAYMENT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            return err?.response?.data || err;
        });
};

export const idfcGetAccountDetail = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_GET_ACCOUNT_DETAIL, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            return err?.response?.data || err;
        });
};

export const idfcMultiPaymentEnquiry = (data = {}) => {
    return axiosInstance
        .post(API.IDFC_MULTI_PAYMENT_ENQUIRY, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err);
            }
            return err?.response?.data || err;
        });
};

